/* YOUER Landing Page v2
   - Two scroll effects (GSAP ScrollTrigger, section-scoped)
   - Two custom Klaviyo signup forms (client/subscriptions API — never an embed)
   Static page is the no-JS / reduced-motion baseline: animations use gsap.from()
   so the DOM's resting state is the final design.
   Re-inits on shopify:section:load — design mode re-renders the section DOM,
   which would otherwise orphan the GSAP bindings and form listeners. */

(function () {
  'use strict';

  var KLAVIYO_REVISION = '2025-01-15';

  function initScrollEffects(root) {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion || !window.gsap || !window.ScrollTrigger) return;

    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.getAll().forEach(function (t) { t.kill(); });

    // Hero circle logo: rolls in place as the hero scrolls past.
    var heroLogo = root.querySelector('[data-youer-hero-logo]');
    if (heroLogo) {
      gsap.to(heroLogo, {
        rotation: 360,
        ease: 'none',
        scrollTrigger: {
          trigger: root.querySelector('[data-youer-hero]'),
          start: 'top top',
          end: 'bottom top',
          scrub: true
        }
      });
    }

    // Colleen logo: rolls in from off-screen left (~2 rotations), easing out
    // as it lands right-aligned. Curve measured from the published page.
    var rollin = root.querySelector('[data-youer-rollin]');
    if (rollin) {
      gsap.from(rollin, {
        x: '-96vw',
        rotation: -720,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: root.querySelector('[data-youer-rollin-section]'),
          start: 'top 95%',
          end: 'top 45%',
          scrub: true
        }
      });
    }
  }

  function subscribe(email, companyId, listId) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'YOUER Landing Page',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: { YOUER_source: 'QR_scan' }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };

    return fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: KLAVIYO_REVISION
        },
        body: JSON.stringify(payload)
      }
    ).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo responded ' + res.status);
    });
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function initForms(root) {
    var companyId = root.getAttribute('data-klaviyo-company');
    var listId = root.getAttribute('data-klaviyo-list');
    var generalListId = root.getAttribute('data-klaviyo-general-list');
    var messages = {
      success: root.getAttribute('data-form-success') || "You're in! Check your inbox for your welcome code.",
      error: root.getAttribute('data-form-error') || 'Something went wrong — please try again.',
      empty: root.getAttribute('data-form-empty') || 'Please enter your email.'
    };

    root.querySelectorAll('[data-youer-form]').forEach(function (form) {
      var input = form.querySelector('input[type="email"]');
      var button = form.querySelector('button[type="submit"]');
      var status = form.querySelector('[data-youer-status]');
      var redirect = form.getAttribute('data-redirect');
      var navigateWhenEmpty = form.hasAttribute('data-navigate-empty');

      function setStatus(text, isError) {
        status.textContent = text;
        status.classList.toggle('is-error', Boolean(isError));
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var email = input.value.trim();

        // "shop all" with no email = bare navigation (agreed v1 behavior)
        if (!email && navigateWhenEmpty && redirect) {
          window.location.href = redirect;
          return;
        }

        if (!email || !validEmail(email)) {
          setStatus(messages.empty, true);
          input.focus();
          return;
        }

        button.disabled = true;
        setStatus('…', false);

        // SyVVwS must resolve first so its "Subscribed to List" event fires before
        // WApvBp creates the subscription record — parallel calls race and the
        // second arrival skips the event (already-subscribed profile), which
        // silently drops the YOUER flow trigger.
        subscribe(email, companyId, listId)
          .then(function () {
            return generalListId ? subscribe(email, companyId, generalListId) : Promise.resolve();
          })
          .then(function () {
            setStatus(messages.success, false);
            form.reset();
            if (redirect) {
              setTimeout(function () {
                window.location.href = redirect;
              }, 1200);
            } else {
              button.disabled = false;
            }
          })
          .catch(function () {
            setStatus(messages.error, true);
            button.disabled = false;
          });
      });
    });
  }

  function init() {
    var root = document.querySelector('[data-youer]');
    if (!root) return;
    initScrollEffects(root);
    initForms(root);
  }

  init();

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
